var _path, _path2, _path3, _path4, _path5, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShipping(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 49,
    viewBox: "0 0 46 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5449 28.7178C6.79042 28.7178 5.36813 27.2955 5.36813 25.541C5.36813 23.7865 6.79042 22.3643 8.5449 22.3643C10.2994 22.3643 11.7217 23.7865 11.7217 25.541C11.7217 27.2955 10.2994 28.7178 8.5449 28.7178Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4287 28.7178C22.6742 28.7178 21.2519 27.2955 21.2519 25.541C21.2519 23.7865 22.6742 22.3643 24.4287 22.3643C26.1832 22.3643 27.6055 23.7865 27.6055 25.541C27.6055 27.2955 26.1832 28.7178 24.4287 28.7178Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1.07947 15.9477C1.08372 15.8391 1.10517 15.7319 1.14301 15.63C1.21096 15.3169 1.3012 15.009 1.41304 14.7087L3.06496 10.6266C3.79562 8.78403 4.55805 6.87797 8.59255 6.87797H12.1188V4.09829C12.12 3.15083 12.497 2.24253 13.1669 1.57257C13.8369 0.902612 14.7452 0.525675 15.6926 0.524414H28.3998C29.3472 0.525675 30.2555 0.902612 30.9255 1.57257C31.5954 2.24253 31.9724 3.15083 31.9736 4.09829V21.5706C31.9734 22.1097 31.8502 22.6417 31.6135 23.1261C31.3768 23.6105 31.0328 24.0346 30.6076 24.3661C30.5021 24.4405 30.3836 24.4944 30.2582 24.525C30.1609 24.5323 30.0639 24.5064 29.9832 24.4516C29.9024 24.3968 29.8426 24.3163 29.8134 24.2232C29.5105 22.9706 28.7808 21.8626 27.7498 21.0895C26.7187 20.3164 25.4507 19.9265 24.1634 19.9866C22.8761 20.0467 21.65 20.5532 20.6955 21.4191C19.741 22.2849 19.1178 23.4561 18.933 24.7315C18.9205 24.8449 18.8665 24.9498 18.7816 25.026C18.6966 25.1022 18.5865 25.1443 18.4723 25.1444H14.5014C14.3872 25.1443 14.2771 25.1022 14.1921 25.026C14.1071 24.9498 14.0532 24.8449 14.0407 24.7315C13.8558 23.4561 13.2327 22.2849 12.2782 21.4191C11.3237 20.5532 10.0976 20.0467 8.81028 19.9866C7.523 19.9265 6.25495 20.3164 5.22392 21.0895C4.1929 21.8626 3.46324 22.9706 3.16026 24.2232C3.13728 24.3149 3.08256 24.3955 3.00581 24.4508C2.92905 24.506 2.83521 24.5323 2.74093 24.525C2.6031 24.5099 2.47274 24.4547 2.36607 24.3661C1.94088 24.0346 1.59686 23.6105 1.36016 23.1261C1.12345 22.6417 1.0003 22.1097 1.00006 21.5706V16.9325C1.00218 16.6027 1.02872 16.2735 1.07947 15.9477ZM12.1188 14.8199V9.26055H8.59255C6.1782 9.26055 5.95583 9.83237 5.28871 11.5161L3.93858 14.8199H12.1188Z",
    fill: "url(#paint0_linear_245_93727)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4723 16.0116C18.4744 16.3269 18.6006 16.6287 18.8236 16.8517C19.0465 17.0746 19.3483 17.2008 19.6636 17.2029H31.9736V14.8203H19.6636C19.3483 14.8224 19.0465 14.9486 18.8236 15.1715C18.6006 15.3945 18.4744 15.6963 18.4723 16.0116Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.93796 14.8201H12.1182V9.26074H8.59194C6.17759 9.26074 5.95522 9.83256 5.28809 11.5163L3.93796 14.8201Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_245_93727)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_245_93727)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.6111 20.8108H36.2281V12.7715H34.5054V20.8108H25.1224C25.0633 21.237 25.0326 21.6667 25.0305 22.0971V29.9985C24.9638 30.4665 25.0068 30.9437 25.1564 31.3921C25.3059 31.8406 25.5578 32.2481 25.8921 32.5824C26.2264 32.9167 26.6339 33.1685 27.0823 33.3181C27.5308 33.4676 28.0079 33.5107 28.4759 33.4439H42.2576C42.7256 33.5107 43.2027 33.4676 43.6512 33.3181C44.0996 33.1685 44.5072 32.9167 44.8414 32.5824C45.1757 32.2481 45.4276 31.8406 45.5771 31.3921C45.7267 30.9437 45.7698 30.4665 45.703 29.9985V22.0971C45.701 21.6667 45.6703 21.237 45.6111 20.8108Z",
    fill: "#52FF00",
    fillOpacity: 0.07
  })), /*#__PURE__*/React.createElement("path", {
    d: "M29.9227 12.7715H34.5051V20.8108H25.1221C25.1826 20.3919 25.2708 19.9776 25.3862 19.5704L26.6151 15.2751C27.04 13.7936 27.3271 12.7715 29.9227 12.7715Z",
    fill: "#10B95E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.6105 20.8108H36.2275V12.7715H40.8099C43.4055 12.7715 43.6926 13.7936 44.1175 15.2751L45.3464 19.5704C45.4618 19.9776 45.55 20.3919 45.6105 20.8108Z",
    fill: "#10B95E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.0695 29.711H29.624C29.3956 29.711 29.1765 29.6202 29.015 29.4587C28.8534 29.2972 28.7627 29.0781 28.7627 28.8496C28.7627 28.6212 28.8534 28.4021 29.015 28.2406C29.1765 28.079 29.3956 27.9883 29.624 27.9883H33.0695C33.2979 27.9883 33.517 28.079 33.6785 28.2406C33.8401 28.4021 33.9308 28.6212 33.9308 28.8496C33.9308 29.0781 33.8401 29.2972 33.6785 29.4587C33.517 29.6202 33.2979 29.711 33.0695 29.711Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_245_93727",
    x: 0.91,
    y: 4.08148,
    width: 44.8234,
    height: 44.6831,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -12.1,
    dy: 3.3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.995
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_245_93727"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_245_93727",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_245_93727",
    x: 5,
    y: -7.22852,
    width: 60.7334,
    height: 60.7031,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_245_93727"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_245_93727",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_245_93727",
    x1: 16.4868,
    y1: -41.4886,
    x2: 15.3681,
    y2: 33.7375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4DFF94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00BD4B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShipping);
export default __webpack_public_path__ + "static/media/Shipping.55aa27792cff0ed5390608216e2d917b.svg";
export { ForwardRef as ReactComponent };